import { Box, LoadingOverlay, Text } from '@mantine/core';
import { i18nKeys, useTranslation } from 'locales';
import { useLoadCei } from 'shared/hooks/use-load-cei';

import { AnalyticsCard } from '../AnalyticsCard';
import { CeiChart } from '../charts';

export const CeiCard = () => {
  const { t } = useTranslation();
  const { cei, isCeiInitialLoading } = useLoadCei();

  return (
    <AnalyticsCard
      title={t(i18nKeys.ANALYTICS.CEI.TITLE)}
      helpContent={<CeiHelpContent />}
      panelProps={{
        pb: 'space6', // override the padding to make the legend look better
      }}
    >
      <Box w="100%" h="400px">
        {isCeiInitialLoading ? <LoadingOverlay visible /> : <CeiChart cei={cei} />}
      </Box>
      <Box id="cei-legend-outlet" />
    </AnalyticsCard>
  );
};

const CeiHelpContent = () => {
  const { t } = useTranslation();

  return (
    <Box>
      <Text fw="bold">{t(i18nKeys.ANALYTICS.CEI.HELP.TITLE)}</Text>
      <br />
      <Text>{t(i18nKeys.ANALYTICS.CEI.HELP.LINE_1)}</Text>
      <br />
      <Text>{t(i18nKeys.ANALYTICS.CEI.HELP.LINE_2)}</Text>
    </Box>
  );
};
